import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-right: 20px;
  border-right: 1px solid ${({ theme }) => theme.pallette.silver.light};
  margin-right: 20px;
  gap: 5px;

  @media (max-width: 1100px) {
    padding-right: 10px;
    margin-right: 10px;
  }
`;

export const SubTitle = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  line-height: 16px;
  color: ${({ theme }) => theme.pallette.silver.dark};
`;

export const StyledLink = styled.a`
  color: ${({ theme }) => theme.pallette.blue.link};
  text-decoration: underline;
  font-size: 12px;
  font-weight: 500;

  &:hover {
    color: ${({ theme }) => theme.pallette.blue.link};
  }
`;
